import { AuthRoles } from "configs/roles";
import { ScheduleUIProvider } from "./ScheduleUIContext";

// MENU
import { ScheduleUICard } from "./ScheduleUICard";
import { AddQuotaSchedule } from "./pages/AddQuotaSchedule";
import { CancelSchedule } from "./pages/CancelSchedule";
import { RemoveSchedule } from "./pages/RemoveSchedule";
import { SettingSchedule } from "./pages/SettingSchedule";

export const ScheduleRoutes = [
  {
    path: "/schedule",
    element: (
      <ScheduleUIProvider>
        <ScheduleUICard />
      </ScheduleUIProvider>
    ),
    auth: AuthRoles.ROLES_USER,
  },
  {
    path: "/schedule/add-quota",
    element: <AddQuotaSchedule />,
    auth: AuthRoles.ROLES_OPERATOR,
  },
  {
    path: "/schedule/:id/cancel",
    element: <CancelSchedule />,
    auth: AuthRoles.ROLES_OPERATOR,
  },
  {
    path: "/schedule/:id/remove",
    element: <RemoveSchedule />,
    auth: AuthRoles.ROLES_OPERATOR,
  },
  {
    path: "/schedule/:id/setting",
    element: <SettingSchedule />,
    auth: AuthRoles.ROLES_USER,
  },
];
